import { SPACING_TOKENS } from '../../constants/tokens.mjs';
import { DEFAULT_POPOVER_LAYOUT } from '../constants.mjs';
import { getPopoverLayout } from './getPopoverLayout.mjs';
import { PopoverCssProperty } from '../../types/style.mjs';
import { domRectToLayout, mergePopoverLayouts } from '../utilities/layout.mjs';

const DEFAULT_OVERRIDES = {
  maxWidth: `var(--osui_width-sidebar-desktop)`,
  maxHeight: `calc(100vh - ${SPACING_TOKENS['space-2']} - var(${PopoverCssProperty.Top}))`
};
function sidebarStrategy({
  options,
  measurements
}) {
  const {
    anchorRect,
    containerSize,
    scrollSize
  } = measurements;
  if (!anchorRect) {
    return DEFAULT_POPOVER_LAYOUT;
  }
  const anchorLayout = domRectToLayout(anchorRect, containerSize);
  const popoverLayout = getPopoverLayout({
    anchorLayout,
    containerSize,
    scrollSize,
    options
  });

  // TODO: investigate that function
  // filterOmissionsFromPopoverLayout(adjustedLayout, DEFAULT_OMISSIONS);
  return mergePopoverLayouts(DEFAULT_OVERRIDES, popoverLayout);
}

export { DEFAULT_OVERRIDES, sidebarStrategy };
